import {
    memo,
    useCallback,
} from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import {
    authState,
} from 'store/state';
import { useModal } from 'hooks';
import { useAuthActions } from 'services';
import {
    AUTH_MODAL,
} from '_constants/modalTypes';

import {
    FasttokenIcon,
} from 'components/Icons';
import WalletDropdown from './WalletDropdown';
import ConnectWalletButton from './ConnectWalletButton';

import StyledHeader from './styles';

const Header = () => {
    const [auth] = useRecoilState(authState);
    const { t } = useTranslation();
    const {
        onOpen: onModalOpen,
    } = useModal();
    const {
        logout,
    } = useAuthActions();

    const onLogout = useCallback(logout, []);

    const openAuthModal = () => {
        onModalOpen(AUTH_MODAL);
    };

    return (
        <StyledHeader>
            <div className="container">
                <a
                    href="https://fasttoken.com/"
                    className="logo"
                >
                    <FasttokenIcon />
                </a>
                <h1 className="page-title">
                    {auth?.currentAddress && process.env.REACT_APP_MODE === 'CLAIM' && (
                        <>
                            <span>FTN</span>
                            claim
                        </>
                    )}
                    {['PRIVATE_SALE_1', 'PRIVATE_SALE_2'].includes(process.env.REACT_APP_MODE) && 'FUTURE TOKEN PURCHASE ORDER'}
                    {process.env.REACT_APP_MODE === 'ADVISORS' && 'SOFTCONSTRUCT EMPLOYEE REWARDS'}
                    {process.env.REACT_APP_MODE === 'ALLOCATIONS' && (
                        <>
                            <span>FTN</span>
                            Distribution
                        </>
                    )}
                </h1>

                <div className="header-actions">
                    {auth?.currentAddress ? (
                        <WalletDropdown
                            t={t}
                            onLogout={onLogout}
                        />
                    ) : (
                        <ConnectWalletButton
                            text={t('connectWallet')}
                            onClick={openAuthModal}
                        />
                    )}
                </div>
            </div>
        </StyledHeader>
    );
};

export default memo(Header);
